import { Common, color } from '@stockbit/ui';

const { IconWrapper, Iconmoon } = Common;
const CloseIcon = (props) => (
  <IconWrapper {...props} size="30px">
    <Iconmoon
      className="icon-widget_close"
      color={color.dimgray}
      hoverColor={color.dimgray}
      size="14px"
      weight="bold"
    />
  </IconWrapper>
);

export default CloseIcon;
